"use client";

import { Message } from "@/lib/core/crm/types";
import { MessageActionHandlers } from "./hooks/useMessageActionHandlers";
import { ActionButton, ACTION_CONFIGS } from "./ActionButton";
import { Button } from "@/components/ui/button";
import { Link } from "lucide-react";
import { MessageMoreActionsMenu } from "./MessageMoreActionsMenu";

interface MessageDesktopInlineActionsProps {
  message: Message;
  handlers: MessageActionHandlers;
  onCopyLink?: () => void;
  onSaveAttachmentsToGoogleDrive?: () => void;
  className?: string;
}

export function MessageDesktopInlineActions({
  message,
  handlers,
  onCopyLink,
  onSaveAttachmentsToGoogleDrive,
  className,
}: MessageDesktopInlineActionsProps) {
  return (
    <div className={`hidden sm:flex items-center space-x-2 flex-shrink-0 ${className || ""}`}>
      {/* Original Desktop Actions - All Inline */}
      <ActionButton config={ACTION_CONFIGS.reply} handlers={handlers} />

      <ActionButton
        config={message.isRead ? ACTION_CONFIGS.markUnread : ACTION_CONFIGS.markRead}
        handlers={handlers}
      />

      <ActionButton config={ACTION_CONFIGS.forward} handlers={handlers} />

      <ActionButton config={ACTION_CONFIGS.archive} handlers={handlers} />

      {onCopyLink && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onCopyLink}
          title="Copy link to this message"
          disabled={handlers.isActionLoading}
        >
          <Link className="h-4 w-4" />
        </Button>
      )}

      {/* More Actions Menu (Create Task, Save to Drive, Delete) */}
      <MessageMoreActionsMenu
        message={message}
        handlers={handlers}
        onSaveAttachmentsToGoogleDrive={onSaveAttachmentsToGoogleDrive}
      />
    </div>
  );
}
